import Utils from '../utils/utils';

import type { FieldDefault, FieldDefaultsObj } from './types';

/**
 * @description
 * The FieldDefaultUtils class contains APIs that handle the field default related operations
 */
class FieldDefaultUtils {
  public fieldDefaults: {
    [fieldType: string]: FieldDefaultsObj;
  };

  constructor() {
    this.fieldDefaults = {};
  }

  /**
   * Updates the field defaults config to current config.
   * @param configs field default configs
   * @example <caption> Example for updateFieldDefaults()</caption>
   * PCore.getFieldDefaultUtils().updateFieldDefaults({ Email: { 'client-validations': false }, Phone: { 'client-validations': false } })
   */
  updateFieldDefaults(configs: FieldDefaultsObj) {
    if (configs) {
      if (!Object.keys(this.fieldDefaults).length) {
        Utils.copy(configs, this.fieldDefaults);
      } else {
        Utils.mergeDeep(configs, this.fieldDefaults);
      }
    }
  }

  /**
   * set the field default config for a component type.
   * @param type component type
   * @param key config key
   * @param value config value
   * @example <caption> Example for setFieldDefault()</caption>
   * PCore.getFieldDefaultUtils().setFieldDefault("Email","client-validations" ,true)
   */
  setFieldDefault(type: string, key: string, value: FieldDefault) {
    if (type && key) {
      this.fieldDefaults[type] = this.fieldDefaults[type] || {};
      if (typeof this.fieldDefaults[type] === 'object' && this.fieldDefaults[type] !== null) {
        this.fieldDefaults[type][key] = value;
      }
    }
  }

  /**
   * get the field default config(formats and styles) for component type.
   * @param type component type
   * @returns field default config for component type.
   * @example <caption> Example for getDefaultsforType()</caption>
   * PCore.getFieldDefaultUtils().getDefaultsforType("Email")
   * // returns -- { 'client-validations': false }
   */
  getDefaultsforType(type: string) {
    return this.fieldDefaults[type];
  }
}

export default new FieldDefaultUtils();
